"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = '/esp-sync/v1/form-subscriptions';
var _default = {
  fetchSubscriptions: function fetchSubscriptions(formGuid) {
    return _apiClient.default.get(BASE_URL + "/" + formGuid, {
      timeout: 30000
    });
  },
  fetchSubscriptionStatus: function fetchSubscriptionStatus(formGuid) {
    return _apiClient.default.get(BASE_URL + "/" + formGuid + "/status");
  },
  bulkUpdateSubscriptions: function bulkUpdateSubscriptions(formGuid, mappings) {
    return _apiClient.default.put(BASE_URL + "/" + formGuid, {
      data: mappings
    });
  },
  getSubscriptionDefinitions: function getSubscriptionDefinitions() {
    return _apiClient.default.get('/email/v1/subscriptions/definitions?includeInternal=true');
  }
};
exports.default = _default;
module.exports = exports.default;